import { TRoamingQcStore } from '@monorepo/types';
import { RoamingQcUtil } from '@monorepo/utils';
import produce from 'immer';
import { INITIAL_CACHE_RESET_TIMESTAMP } from '../metadata/metadata.reducer';
import { RoamingQcStoreActionTypes, TRoamingQcStoreActions } from './roaming-qc-db.actions';
export const EPF_CACHE_STORAGE_TIME = 7 * 24 * 60 * 60 * 1000;
export function getRoamingQcStoreInitalState(nextCacheResetTimestamp: number) {
  const roamingQcStoreInitalState: TRoamingQcStore = {
    lockDetails: {
      isLocked: false,
      lockedBy: 'NONE',
    },
    transactions: {},
    roamingQcDB: {
      nextCacheResetTimestamp: nextCacheResetTimestamp,
      dailyCache: {
        inProgressDetails: {
          lineMap: {},
        },
        recentCategoryList: {},
        lineShiftWiseRoundInfo: { lineMap: {} },
      },
      persistanceCache: {
        epfDetails: {
          lineMap: {},
        },
      },
    },
  };
  return roamingQcStoreInitalState;
}
export const roamingQcStoreInitalState: TRoamingQcStore = getRoamingQcStoreInitalState(INITIAL_CACHE_RESET_TIMESTAMP);

export function RoamingQcStoreStateReducer(
  state: TRoamingQcStore = roamingQcStoreInitalState,
  action: TRoamingQcStoreActions,
): TRoamingQcStore {
  switch (action.type) {
    case RoamingQcStoreActionTypes.UpdateRoamingQcStoreLockDetails: {
      return produce(state, (draft) => {
        draft.lockDetails = action.lockDetails;
      });
    }
    case RoamingQcStoreActionTypes.UpdateEpfDetailsAndRecentCategoryListAndReleaseLock:
    case RoamingQcStoreActionTypes.UpdateInProgressDetailsAndReleaseLock:
    case RoamingQcStoreActionTypes.ClearInProgressDetailsAndReleaseLock:
    case RoamingQcStoreActionTypes.UpdateStoreAndReleaseLockAndThenGoToInspection:
    case RoamingQcStoreActionTypes.UpdateStoreAndReleaseLock: {
      return produce(state, (draft) => {
        draft.roamingQcDB = action.roamingQcDB;
        draft.lockDetails = {
          isLocked: false,
          lockedBy: 'NONE',
        };
      });
    }
    case RoamingQcStoreActionTypes.ClearTransactionLogRecordsAndReleaseLock: {
      return produce(state, (draft) => {
        draft.transactions = {};
        draft.lockDetails = {
          isLocked: false,
          lockedBy: 'NONE',
        };
      });
    }
    case RoamingQcStoreActionTypes.UpdateTransactionLogRecordsAndReleaseLock: {
      return produce(state, (draft) => {
        draft.transactions = { response: action.transactions };
        draft.lockDetails = {
          isLocked: false,
          lockedBy: 'NONE',
        };
      });
    }
    case RoamingQcStoreActionTypes.ReleaseRoamingQcLock: {
      return produce(state, (draft) => {
        draft.lockDetails = {
          isLocked: false,
          lockedBy: 'NONE',
        };
      });
    }
    default:
      return state;
  }
}
